import React, { useContext } from 'react';
import { Web3Context } from '../../context/Web3Context';
import { shortenAddress } from '../../utils/formatters';
import './Header.css';

export default function Header() {
  const { account, userId, disconnectWallet } = useContext(Web3Context);

  return (
    <header className="header">
      <div className="header-left">
        <img src="/uvw.png" alt="UVW" className="header-logo" />
        <span className="header-brand">UVW</span>
      </div>
      <div className="header-right">
        {userId && <span className="header-uid">ID: {userId}</span>}
        {account && (
          <div className="header-wallet" onClick={disconnectWallet}>
            <span className="header-wallet-dot" />
            <span>{shortenAddress(account)}</span>
          </div>
        )}
      </div>
    </header>
  );
}
